import { DOMAIN } from "./../utilities/consts";

class DrivingApi {
  static getDrivingData(config) {
    return fetch(`${DOMAIN}/ZeekAppsWS.asmx/ObtenerDatosDriving`, {
      method: "POST",
      body: JSON.stringify(config),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      credentials: "include"
    })
      .then(response => response.json())
      .then(data => JSON.parse(data.d));
  }

  static getDrivingDataFake() {
    return fetch(`/fakedata/driving.json`)
      .then(response => response.json())
      .then(data => data);
  }

  static changeDrivingConfiguration(configurationData) {
    const data = {
      configuracion: configurationData
    };

    return fetch(`${DOMAIN}/ZeekAppsWS.asmx/GuardarConfiguracionDriving`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      credentials: "include"
    })
      .then(response => response.json())
      .then(data => JSON.parse(data.d));
  }

  static getDrivingConfiguration() {
    return fetch(`${DOMAIN}/ZeekAppsWS.asmx/ObtenerConfiguracionDriving`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      credentials: "include"
    })
      .then(response => response.json())
      .then(data => JSON.parse(data.d));
  }

  static getDrivingConfigurationFake() {
    // return new Promise((resolve, reject) => {
    //   setTimeout(() => {
    //     resolve(fakeDrivingConfiguration);
    //   }, DELAY);
    // });
    return fetch(`/fakedata/drivingConfiguration.json`)
      .then(response => response.json())
      .then(data => data);
  }

  static saveDrivingConfiguration(drivingConfiguration) {
    const data = {
      configuracion: drivingConfiguration
    };

    return fetch(`${DOMAIN}/ZeekAppsWS.asmx/GuardarConfiguracionDriving`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      credentials: "include"
    })
      .then(response => response.json())
      .then(data => JSON.parse(data.d));
  }
}

export default DrivingApi;



// WEBPACK FOOTER //
// ./src/api/drivingApi.js